'use client';

import { useEffect } from 'react';

import { configureAmplify } from '../utils/client';

/**
 * This component is used to configure Amplify in the application.
 */
export const ConfigureAmplify = () => {
  useEffect(() => {
    configureAmplify();
  }, []);

  return null;
};
